<template>
    <div class="pl-16px text-16px line-height-28px">
        <p>{{ t('publicBetaAgreement.line0') }}</p>
        <p>{{ t('publicBetaAgreement.line2') }}</p>
        <p>{{ t('publicBetaAgreement.line3') }}</p>
        <p>
            {{ t('publicBetaAgreement.line4') }}
        </p>
        <p>{{ t('publicBetaAgreement.line5') }}</p>
        <p>{{ t('publicBetaAgreement.line6') }}</p>
        <p>{{ t('publicBetaAgreement.line7') }}</p>
        <p>{{ t('publicBetaAgreement.line8') }}</p>
        <p>{{ t('publicBetaAgreement.line9') }}</p>
        <p>{{ t('publicBetaAgreement.line10') }}</p>
        <p>{{ t('publicBetaAgreement.line11') }}</p>
        <p>
            {{ t('publicBetaAgreement.line12') }}
        </p>
        <p>
            {{ t('publicBetaAgreement.line13') }}
        </p>
        <p>{{ t('publicBetaAgreement.line14') }}</p>
        <p>{{ t('publicBetaAgreement.line15') }}</p>
        <p>{{ t('publicBetaAgreement.line16') }}</p>
        <p>{{ t('publicBetaAgreement.line17') }}</p>
        <p>{{ t('publicBetaAgreement.line18') }}</p>
        <p>{{ t('publicBetaAgreement.line19') }}</p>
        <p>
            <span>{{ t('publicBetaAgreement.line20') }}</span>
            <span>Brain@baai.ac.cn】</span>
            <span>{{ t('publicBetaAgreement.line21') }}</span>
        </p>
    </div>
</template>
<script setup lang="tsx">
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>
